import { apiClient } from './apiService';

const friendService = {
  /** Send a friend request to userId. */
  sendRequest(userId) {
    return apiClient.post(`/friends/${userId}`).then((r) => r.data);
  },

  /** Accept an incoming friend request from userId. */
  acceptRequest(userId) {
    return apiClient.put(`/friends/${userId}/accept`).then((r) => r.data);
  },

  /** Reject an incoming friend request from userId. */
  rejectRequest(userId) {
    return apiClient.put(`/friends/${userId}/reject`).then((r) => r.data);
  },

  /** Cancel an outgoing request or remove an existing friendship with userId. */
  removeRelationship(userId) {
    return apiClient.delete(`/friends/${userId}`).then((r) => r.data);
  },

  /** Get friendship status between the current viewer and userId. */
  getStatus(userId) {
    return apiClient.get(`/friends/${userId}/status`).then((r) => r.data);
  },

  /** Get own accepted friends list (paginated). */
  getFriends({ page = 1, limit = 20 } = {}) {
    return apiClient.get('/friends', { params: { page, limit } }).then((r) => r.data);
  },

  /** Get own incoming pending requests. */
  getPendingRequests({ page = 1, limit = 20 } = {}) {
    return apiClient.get('/friends/requests', { params: { page, limit } }).then((r) => r.data);
  },
};

export default friendService;
